import { useMemo } from "react";

export default function useFormRoles(userActions) {
  return useMemo(() => {
    const roles = {};
    userActions?.forEach((role) => {
      roles[`is${role}`] = true;
    });
    return roles;
  }, [userActions]);
}